import { render, staticRenderFns } from "./AppDialogMessageBox.vue?vue&type=template&id=61341036"
import script from "./AppDialogMessageBox.vue?vue&type=script&lang=js"
export * from "./AppDialogMessageBox.vue?vue&type=script&lang=js"
import style0 from "./AppDialogMessageBox.vue?vue&type=style&index=0&id=61341036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports